import { MenuOutlined } from '@ant-design/icons';
import { useUser } from '@dofleini/security';
import { Button, Layout } from 'antd';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { lazy, memo, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

import Logo from '@/components/Logo';
import UserDropdown from '@/components/UserDropdown';
import { useResponsive } from '@/contexts/ResponsiveContext';
import { useSidebar } from '@/contexts/SidebarContext';
import PublicNavMenu from '@/layout/MainHeader/NavMenu';
import { useSettings } from '@/modules/configuration/hooks/useSettings';
import { ROUTE_USER_PATH_PROPOSAL_REQUEST } from '@/modules/proposalRequest/contants/proposalRequest';

import style from '../index.less';

const loadAddProposalButton = () => import('@/layout/MainHeader/AddProposalButton');
export const AddProposalButton = lazy(loadAddProposalButton);

const { Header } = Layout;

const MainHeader = ({ isCenter, inverse }) => {
  const { t } = useTranslation('navigation');
  const { toggleCollapsed } = useSidebar();
  const { isAuthenticated } = useUser();
  const { isMobile } = useResponsive();
  const { data: configurations } = useSettings();
  const { push } = useHistory();
  
  const handleRequest = useCallback(() => {
    push(ROUTE_USER_PATH_PROPOSAL_REQUEST);
  }, [push]);
  
  return (<Header
    className={classNames(style.globalHeader, 'flex w-full fixed top-0 z-40 items-center pae-header')}
    id="global-app-top-header">
    <div className={classNames('flex items-center w-full', { 'pageViewport': isCenter })}>
      <div className={classNames('flex items-center', { ' md:ml-0 ml-4': !isAuthenticated })}>
        {isAuthenticated && <Button
          type={'text'}
          size={'large'}
          className="xml:hidden"
          onClick={toggleCollapsed}>
          <MenuOutlined/>
        </Button>}
        <Logo className={classNames('flex items-center justify-between mx-0 xml:mx-3 md:-ml-4')} mini={isMobile}/>
      </div>
      <div className={classNames('flex items-center flex-1 md:truncate justify-end mr-4')}>
        <div className="font-semibold"><PublicNavMenu inverse={inverse}/></div>
        {!isAuthenticated && !configurations?.inMaintenance ?
          <div className={classNames('flex items-center mr-4')}>
            <Button
              size={'large'}
              type={inverse ? 'default' : 'primary'}
              onClick={handleRequest}>
              {t('request')}
            </Button>
          </div> :
          <AddProposalButton t={t}/>
        }</div>
      <div className="mr-2"><UserDropdown/></div>
    </div>
  </Header>
  );
};

export default memo(MainHeader);

MainHeader.propTypes = {
  inverse: PropTypes.bool,
  isCenter: PropTypes.bool
};
